import { SelectionProps } from "~/pages/space/vulnerabilities/components/exposed-assets/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { Loading, LoadingFailed } from "~/components/loading";
import { Grid } from "@mui/material";
import { ExposedAssetsTable } from "./components/ExposedAssetsTable";
import { EmptySection } from "~/components/vulnerabilities";
import { usePolicyAssets } from "./hooks/usePolicyAssets";

interface ExposedAssetsSecurityPolicyTabProps {
  scope: SpaceOrWorkspaceScope;
  selectionProps?: SelectionProps | undefined;
}

export const ExposedAssetsSecurityPolicyTab = ({
  scope,
  selectionProps,
}: ExposedAssetsSecurityPolicyTabProps) => {
  const {
    assets,
    sort,
    filteredTotalCount,
    pageInfo,
    fetchMore,
    error,
    loading,
  } = usePolicyAssets({
    scope,
  });

  if (error) {
    return <LoadingFailed what="assets" />;
  }

  if (loading) {
    return <Loading what="assets" />;
  }

  return (
    <Grid id="exposed-assets" size={12}>
      {(assets?.length || 0) > 0 && !error ? (
        <ExposedAssetsTable
          scopeParams={scope.params}
          assets={assets}
          sort={sort}
          filteredTotalCount={filteredTotalCount || 0}
          pageInfo={pageInfo}
          fetchMore={fetchMore}
          selectionProps={selectionProps}
          urlContextType={"ASSET"}
          contextId={""}
        />
      ) : (
        <EmptySection
          id="affected-assets-list-empty"
          text={`There are currently no exposed assets for this policy`}
        />
      )}
    </Grid>
  );
};
